export const AccessActionTypes = {
  ACCESS_LOADED: "ACCESS_LOADED",
  ACCESS_CLEARED: "ACCESS_CLEARED",
};

/**
 * What the auth server stores for this user against the portal's client (the
 * `clientId` from config.json), in the free-form `appAccess.access` object.
 * Our convention:
 *
 *   { "role": "Administrator", "pages": ["account-management"] }
 *
 * `role` records the account type the security requirements call for
 * (Administrator / Standard). `pages` is what actually gates routes and menu
 * entries — a new gated page just appends a key, with no code change here.
 *
 * The auth server only stores this; deciding what it means is our job.
 */
export interface AppAccessState {
  role: string | null;
  pages: string[];
  /** False until the first fetch settles, so the UI can avoid flicker. */
  loaded: boolean;
}

export const PAGE_ACCOUNT_MANAGEMENT = "account-management";
export const ROLE_ADMINISTRATOR = "Administrator";
